import React, { useState } from 'react';
import { Package } from 'lucide-react';

interface Props {
  src?: string | null;
  alt: string;
  className?: string;
}

function ProductImage({ src, alt, className }: Props) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div className={`product-image-placeholder ${className ?? ''}`} aria-label={alt}>
        <Package size={36} strokeWidth={1.5} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
    />
  );
}

export default ProductImage;
